import { store } from "redux/store";

const getCurrentLanguage = () => {
  let currentLanguage = store?.getState()?.app?.language;

  return currentLanguage;
};

export default getCurrentLanguage;
